import { GetCourseByIdResponse, GetCoursesResponse } from 'models/lectures/ApiModels/lectures'
import { CourseById, Courses } from 'models/lectures/EntityModels/lectures'

export const deserializeCourses = (data: GetCoursesResponse): Courses => {
  return {
    count: data.count || 0,
    items: data.items.map(item => ({
      id: item.id || 0,
      name: item.name || '',
      year: item.year || 0,
      videoCount: item.video_count || 0,
      preview: item.preview || '',
      slug: item.slug || ''
    }))
  }
}

export const deserializeCourse = (data: GetCourseByIdResponse): CourseById => {
  return {
    id: data.id || 0,
    slug: data.slug || '',
    count: data.count || 0,
    items: data.items.map(item => ({
      id: item.id || 0,
      title: item.title || '',
      name: item.name || '',
      description: item.description || '',
      authors: item.authors.map(author => {
        return {
          id: author.id || 0,
          name: author.name || '',
          description: author.description || ''
        }
      }),
      course: item.course || {
        id: 0,
        name: '',
        year: 0
      },
      video: item.video || '',
      slug: item.slug,
      pdfLink: item.pdf_link || '',
      audioLink: item.audio_link || ''
    }))
  }
}
